import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import { css } from '@patternfly/react-styles';
import { NavContext } from './Nav';
export var NavItem = function NavItem(_a) {
  var children = _a.children,
      _a$styleChildren = _a.styleChildren,
      styleChildren = _a$styleChildren === void 0 ? true : _a$styleChildren,
      className = _a.className,
      to = _a.to,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$groupId = _a.groupId,
      groupId = _a$groupId === void 0 ? null : _a$groupId,
      _a$itemId = _a.itemId,
      itemId = _a$itemId === void 0 ? null : _a$itemId,
      _a$preventDefault = _a.preventDefault,
      preventDefault = _a$preventDefault === void 0 ? false : _a$preventDefault,
      _a$onClick = _a.onClick,
      _onClick = _a$onClick === void 0 ? null : _a$onClick,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'a' : _a$component,
      props = __rest(_a, ["children", "styleChildren", "className", "to", "isActive", "groupId", "itemId", "preventDefault", "onClick", "component"]);

  var Component = component;

  var renderDefaultLink = function renderDefaultLink(context) {
    var preventLinkDefault = preventDefault || !to;
    return React.createElement(Component, Object.assign({
      href: to,
      onClick: function onClick(e) {
        return context.onSelect(e, groupId, itemId, to, preventLinkDefault, _onClick);
      },
      className: css(styles.navLink, isActive && styles.modifiers.current, className),
      "aria-current": isActive ? 'page' : null
    }, props), children);
  };

  var renderClonedChild = function renderClonedChild(context, child) {
    var childClass = child.props && child.props.className;
    var childClassName = styleChildren ? css(styles.navLink, isActive && styles.modifiers.current, childClass) : childClass;
    return React.cloneElement(child, {
      onClick: function onClick(e) {
        return context.onSelect(e, groupId, itemId, to, preventDefault, _onClick);
      },
      className: childClassName,
      'aria-current': isActive ? 'page' : null
    });
  };

  return React.createElement("li", {
    className: css(styles.navItem, className)
  }, React.createElement(NavContext.Consumer, null, function (context) {
    return React.isValidElement(children) ? renderClonedChild(context, children) : renderDefaultLink(context);
  }));
};